import "./page/list";
import "./component/sidebar-filter"

Shopware.Module.register("neti-incomplete_order_reminder_email_log", {
    type: "plugin",
    name: "IncompleteOrderReminder Mail-Log",
    title: "neti-incomplete-order-reminder.main.logMenuItemGeneral",
    icon: "regular-database",
    color: "#ff3d58",
    entity: "neti_incomplete_order_reminder_mail_log",
    routes: {
        list: {
            component: "email-log-list",
            path: "list",
            meta: {
                privilege: "customer.viewer",
            },
        },
    },

    settingsItem: {
        group: "plugins",
        to: "neti.incomplete_order_reminder_email_log.list",
        iconComponent: "neti-ior-settings-icon",
        backgroundEnabled: false,
    },
});
